const INITIAL_STATE = {};

// reducers
const actionHandlers = new Map([]);

const EmailReducer = (state = INITIAL_STATE, action = { type: null }) =>
  actionHandlers.has(action.type) ? actionHandlers.get(action.type)(state, action) : state;

export default EmailReducer;